import Swal from 'sweetalert2'

const showPopup = (iconPopup, titlePopup) => {
  Swal.fire({
    position: 'center',
    icon: iconPopup,
    title: titlePopup,
    showConfirmButton: false,
    timer: 2500
  })
}

const showErrorDevice = (iconPopup, titlePopup, textPopup) => {
  Swal.fire({
    position: 'center',
    title: titlePopup,
    text: textPopup,
    icon: iconPopup,
    confirmButtonText: 'Cerrar'
  })
}

export { showPopup, showErrorDevice }
